export const STATE_VIEW = {
  INIT: "INIT",
  GET_SESSION: "GET_SESSION",
  RENDER: "RENDER",
}
